import { createFileRoute } from "@tanstack/react-router";
import { authCallbackLoader } from "@/lib/server-fns/auth";

export const Route = createFileRoute("/auth/callback")({
  beforeLoad: async () => {
    await authCallbackLoader();
  },
  component: () => null,
});
